var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_34728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 407.845L847.76 404.382V654.329L774.826 605.53L668.856 651.2L561.64 605.529L468.761 692.489L368.401 721.269L324.147 684.358L289.24 631.181L256.203 663.085L182.646 601.149L131.531 608.655L74.184 559.233L0 540.466V407.845Z",
    fill: "#384252",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.889 211.14L669.019 271.557L669.222 541.618C671.983 541.618 675.974 541.618 677.407 541.618C680.73 541.503 682.663 541.519 693.266 540.512C696.54 540.198 696.335 540.357 710.25 539.412C728.052 538.464 735.826 537.209 748.516 536.097L748.719 268.877L735.727 216.503C736.28 215.383 685.303 210.793 658.889 211.14Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.829 377.706C733.573 377.706 824.969 363.933 824.969 346.945C824.969 329.956 733.573 316.184 620.829 316.184C508.086 316.184 416.689 329.956 416.689 346.945C416.689 363.933 508.086 377.706 620.829 377.706Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.829 543.983C733.573 543.983 824.969 530.211 824.969 513.222C824.969 496.233 733.573 482.461 620.829 482.461C508.086 482.461 416.689 496.233 416.689 513.222C416.689 530.211 508.086 543.983 620.829 543.983Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M825.045 515.117C825.045 515.117 822.342 543.376 620.829 543.376C413.985 543.376 416.689 515.117 416.689 515.117V345.124C416.689 345.124 417.627 314.364 620.829 314.364C825.983 314.364 825.045 345.124 825.045 345.124V515.117Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.976 201.607H571.347V213.414H575.976V201.607Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.629 205.108V218.128L511.044 217.521V205.108H507.629Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.629 208.611L575.976 205.109V201L507.629 204.589V208.611Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.928 209.825L520.164 215.582L526.795 215.057L507.8 204.501L507.928 209.825Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.104 206.324L588.341 212.081L594.972 211.556L575.976 201L576.104 206.324Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.347 201.243V204.806",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.044 206.911V204.464",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.572 203.004C574.585 203.507 574.192 203.923 573.689 203.934C573.186 203.945 572.766 203.546 572.752 203.043C572.737 202.541 573.132 202.124 573.634 202.114C574.137 202.103 574.556 202.502 574.572 203.004Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.531 272.748C655.512 273.223 641.291 273.852 624.716 273.536C418.044 269.593 415.793 241.199 415.793 241.199V517.725C415.793 517.725 415.793 547.712 626.252 547.712C642.213 547.712 649.02 547.712 669.632 546.617",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.531 272.748C655.512 273.223 641.291 273.852 624.716 273.536C418.044 269.593 415.793 241.199 415.793 241.199V517.725C415.793 517.725 415.793 547.712 626.252 547.712C642.213 547.712 649.02 547.712 669.632 546.617",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.767 213.566V230.903H434.576V212.96L431.767 213.566Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.846 211.747V223.554H469.475V212.354L464.846 211.747Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.259 211.14H445.63V227.869H450.259V211.14Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.007 218.556L429.038 214.62L437.131 212.575L446.031 211.747L460.473 211.619L473.707 212.961L483.027 215.003L490.337 217.664L486.082 218.294L483.857 217.687L473.541 215.462L460.693 214.046L446.03 213.869L437.333 214.451L429.947 216.069L427.215 218.699L428.836 219.485L429.949 220.213L433.236 221.935L436.422 223.503L440.619 225.576L442.794 226.183L440.467 226.84L439.405 226.385L436.067 225.071L433.084 223.351L430.353 221.733L428.735 220.62L427.319 219.837L427.007 218.556Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.627 213.553C467.638 213.888 467.374 214.166 467.039 214.173C466.703 214.18 466.424 213.914 466.414 213.579C466.404 213.244 466.668 212.967 467.003 212.959C467.337 212.952 467.617 213.218 467.627 213.553Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.551 212.872C448.56 213.165 448.33 213.408 448.036 213.415C447.743 213.421 447.498 213.188 447.49 212.896C447.48 212.603 447.711 212.36 448.005 212.353C448.298 212.347 448.543 212.579 448.551 212.872Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.767 214.416C433.775 214.668 433.578 214.875 433.325 214.881C433.074 214.886 432.863 214.687 432.857 214.436C432.849 214.185 433.046 213.977 433.298 213.971C433.55 213.965 433.76 214.165 433.767 214.416Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.828 218.556V235.286L431.636 237.106V220.377L428.828 218.556Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.231 540.953C825.966 533.698 825.046 516.938 825.046 516.938V241.199C825.046 241.199 825.046 256.974 748.311 265.965",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.231 540.953C825.966 533.698 825.046 516.938 825.046 516.938V241.199C825.046 241.199 825.046 256.974 748.311 265.965",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.806 215.959C739.746 234.525 744.526 250.349 748.72 267.385L734.806 215.959Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.806 215.959C739.746 234.525 744.526 250.349 748.72 267.385",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.426 273.064C655.211 273.537 640.887 273.854 625.638 273.854C509.718 273.696 415.793 259.499 415.793 241.833C415.793 224.164 509.715 211.545 625.638 211.545C641.397 211.545 644.464 210.914 659.196 211.229",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.426 273.064C655.211 273.537 640.887 273.854 625.638 273.854C509.718 273.696 415.793 259.499 415.793 241.833C415.793 224.164 509.715 211.545 625.638 211.545C641.397 211.545 644.464 210.914 659.196 211.229",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.334 265.964H748.31V540.864H749.334V265.964Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.419 216.031C782.177 221.866 825.045 228.106 825.045 241.514C825.045 252.556 796.809 261.372 748.928 266.35",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.419 216.031C782.177 221.866 825.045 228.106 825.045 241.514C825.045 252.556 796.809 261.372 748.928 266.35",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5298 306.425C48.1098 306.425 24.2578 333.065 24.2578 365.924V383.279C24.2578 416.137 48.1098 442.778 77.5298 442.778H321.698C351.124 442.778 374.973 416.138 374.973 383.279V365.924C374.973 333.065 351.124 306.425 321.698 306.425H77.5298Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.573 431.013C115.573 431.013 115.573 432.076 116.619 438.638C117.546 444.452 122.17 442.703 122.17 442.703V462.228L115.573 473.388V431.013Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.683 421.875H94.207V473.388H115.683V421.875Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.475 479.455L274.877 465.89V442.156C274.877 442.156 279.501 444.282 280.428 437.214C281.475 429.236 281.475 427.944 281.475 427.944V479.455Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.841 427.944H281.365V479.457H302.841V427.944Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5298 306.824C48.1098 306.824 24.2578 333.308 24.2578 365.974V383.228C24.2578 415.893 48.1098 442.378 77.5298 442.378",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5298 306.824C48.1098 306.824 24.2578 333.308 24.2578 365.974V383.228C24.2578 415.893 48.1098 442.378 77.5298 442.378",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.752 307.642V276.336H315.701V307.642C315.701 307.642 305.206 321.302 285.725 321.302C266.571 321.302 255.752 307.642 255.752 307.642Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.697 275.955H250.756V287.361H320.697V275.955Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.98 305.816V289.182H176.449V305.816C176.449 305.816 174.966 311.253 172.214 311.253C169.508 311.253 167.98 305.816 167.98 305.816Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.575 287.056H165.241V289.182H178.575V287.056Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.816 306.877V290.243H148.285V306.877C148.285 306.877 146.802 311.101 144.05 311.101C141.345 311.101 139.816 306.877 139.816 306.877Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.411 288.118H137.077V290.243H150.411V288.118Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.881 306.877V290.243H119.35V306.877C119.35 306.877 117.867 310.494 115.115 310.494C112.409 310.495 110.881 306.877 110.881 306.877Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.475 288.118H108.141V290.243H121.475V288.118Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4902 306.877V290.243H91.9592V306.877C91.9592 306.877 90.4762 311.101 87.7242 311.101C85.0182 311.101 83.4902 306.877 83.4902 306.877Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.084 288.118H80.75V290.243H94.084V288.118Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.304 442.377C350.723 442.377 374.576 415.893 374.576 383.227V365.973C374.576 333.308 350.724 306.823 321.304 306.823",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.304 442.377C350.723 442.377 374.576 415.893 374.576 383.227V365.973C374.576 333.308 350.724 306.823 321.304 306.823",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M429.926 517.947C424.615 515.83 420.822 513.498 418.23 510.883C416.205 508.842 415.076 505.562 415.076 505.562L414.743 518.479C414.743 518.479 414.743 520.118 428.941 527.707C432.365 529.537 439.602 531.832 443.303 533.005C446.934 534.157 454.446 535.546 458.171 536.349C462.663 537.315 471.656 539.215 476.175 540.048C481.319 540.996 496.809 542.88 496.809 542.88L518.251 544.69C518.251 544.69 535.452 546.296 541.183 546.671C546.953 547.048 558.491 547.893 564.27 548.062C570.538 548.245 583.082 548.635 589.353 548.669C596.459 548.707 610.669 549.503 617.774 549.453C624.425 549.406 637.723 549.652 644.372 549.453C650.841 549.259 669.635 549.099 669.635 549.099V537.004C669.635 537.004 659.251 537.71 643.138 537.859C633.441 537.949 621.89 537.451 609.763 537.568C592.943 537.729 575.015 536.771 559.395 536.103C546.499 535.553 535.176 535.395 527.347 534.528C521.338 533.861 507.608 532.366 495.297 531.097C481.55 529.68 479.751 529.702 467.8 526.928C461.265 525.41 454.95 524.54 448.606 523.068C448.606 523.068 434.423 519.741 429.926 517.947Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.293 508.87H600.501V559.441H605.293V508.87Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.063 508.87H633.271V559.441H638.063V508.87Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.981 517.512H589.106V533.593H648.981V517.512Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.989 557.364H598.893V562.826H606.989V557.364Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.934 508.939H599.864V505.297H601.727V504.042H604.113V505.277H605.935L605.934 508.939Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.601 525.552C608.601 528.703 606.047 531.256 602.898 531.256C599.748 531.256 597.194 528.703 597.194 525.552C597.194 522.404 599.748 519.85 602.898 519.85C606.047 519.849 608.601 522.402 608.601 525.552Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.877 525.55C606.877 527.746 605.096 529.528 602.9 529.528C600.704 529.528 598.923 527.746 598.923 525.55C598.923 523.356 600.704 521.573 602.9 521.573C605.096 521.573 606.877 523.354 606.877 525.55Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.911 525.56L604.732 526.762L602.911 525.56Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.911 525.56L604.732 526.762",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.246 525.54C603.246 525.719 603.101 525.863 602.922 525.863C602.743 525.863 602.597 525.719 602.597 525.54C602.597 525.361 602.743 525.215 602.922 525.215C603.101 525.215 603.246 525.36 603.246 525.54Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.925 528.959L601.686 527.668L600.925 528.959Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.925 528.959L601.686 527.668",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.422 527.524L600.659 526.787L599.422 527.524Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.422 527.524L600.659 526.787",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.967 525.513H600.374H598.967Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.967 525.513H600.374",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.53 523.554L600.741 524.235L599.53 523.554Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.53 523.554L600.741 524.235",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.977 522.174L601.696 523.344L600.977 522.174Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.977 522.174L601.696 523.344",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.923 521.625V523.032V521.625Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.923 521.625V523.032",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.867 522.174L604.167 523.369L604.867 522.174Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.867 522.174L604.167 523.369",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.302 523.608L605.108 524.254L606.302 523.608Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.302 523.608L605.108 524.254",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.811 525.472H605.431H606.811Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.811 525.472H605.431",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.382 527.496L605.08 526.728L606.382 527.496Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.382 527.496L605.08 526.728",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.881 528.933L604.155 527.712L604.881 528.933Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.881 528.933L604.155 527.712",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.873 525.553C606.873 527.749 605.091 529.531 602.895 529.531C600.699 529.531 598.918 527.749 598.918 525.553C598.918 523.358 600.699 521.576 602.895 521.576C605.09 521.576 606.873 523.357 606.873 525.553Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.203 336.088C825.203 346.457 795.184 355.698 748.355 361.69L825.203 336.088Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.203 336.088C825.203 346.457 795.184 355.698 748.355 361.69",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.575 364.248C653.572 364.897 636.816 365.241 619.557 365.241C507.051 365.241 415.849 350.598 415.849 332.535",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.575 364.248C653.572 364.897 636.816 365.241 619.557 365.241C507.051 365.241 415.849 350.598 415.849 332.535",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.472 457.736C653.469 458.383 636.713 458.729 619.454 458.729C506.948 458.729 415.746 444.086 415.746 426.023",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.472 457.736C653.469 458.383 636.713 458.729 619.454 458.729C506.948 458.729 415.746 444.086 415.746 426.023",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.894 429.576C824.894 439.945 795.007 449.186 748.381 455.178L824.894 429.576Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.894 429.576C824.894 439.945 795.007 449.186 748.381 455.178",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.038 338.732C429.053 339.235 428.658 339.651 428.156 339.662C427.654 339.673 427.234 339.274 427.218 338.771C427.204 338.269 427.598 337.852 428.1 337.842C428.603 337.831 429.023 338.229 429.038 338.732Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.509 332.516C418.523 333.019 418.129 333.435 417.627 333.446C417.125 333.457 416.704 333.058 416.69 332.555C416.675 332.053 417.07 331.636 417.572 331.626C418.075 331.615 418.494 332.013 418.509 332.516Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.468 360.549C644.482 361.052 644.088 361.468 643.585 361.479C643.083 361.49 642.663 361.091 642.648 360.588C642.634 360.086 643.028 359.669 643.53 359.659C644.033 359.648 644.453 360.046 644.468 360.549Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.957 360.549C616.971 361.052 616.577 361.468 616.074 361.479C615.572 361.49 615.152 361.091 615.137 360.588C615.122 360.086 615.517 359.669 616.019 359.659C616.522 359.648 616.942 360.046 616.957 360.549Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.446 359.942C589.461 360.445 589.067 360.861 588.564 360.872C588.061 360.883 587.642 360.484 587.626 359.981C587.611 359.479 588.006 359.062 588.508 359.052C589.013 359.041 589.433 359.44 589.446 359.942Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.364 359.345C564.378 359.848 563.984 360.264 563.481 360.275C562.979 360.286 562.559 359.887 562.544 359.384C562.529 358.882 562.924 358.465 563.426 358.455C563.929 358.444 564.349 358.842 564.364 359.345Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.367 357.828C540.381 358.331 539.987 358.747 539.485 358.758C538.982 358.769 538.563 358.37 538.548 357.867C538.533 357.365 538.927 356.948 539.43 356.938C539.932 356.927 540.352 357.325 540.367 357.828Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.435 355.907C517.449 356.41 517.055 356.826 516.552 356.837C516.05 356.848 515.63 356.449 515.615 355.946C515.6 355.444 515.995 355.027 516.497 355.017C517 355.005 517.42 355.403 517.435 355.907Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.993 353.783C496.007 354.286 495.613 354.702 495.11 354.713C494.608 354.724 494.188 354.325 494.173 353.822C494.158 353.32 494.553 352.903 495.055 352.893C495.557 352.881 495.977 353.28 495.993 353.783Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.36 350.386C475.374 350.889 474.98 351.305 474.477 351.316C473.975 351.327 473.555 350.928 473.54 350.425C473.525 349.922 473.92 349.506 474.422 349.496C474.925 349.485 475.345 349.884 475.36 350.386Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.356 347.531C457.371 348.034 456.977 348.45 456.474 348.461C455.972 348.472 455.552 348.073 455.536 347.57C455.521 347.068 455.916 346.651 456.418 346.641C456.922 346.63 457.342 347.028 457.356 347.531Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.489 343.485C442.504 343.988 442.109 344.404 441.607 344.415C441.105 344.426 440.685 344.027 440.669 343.524C440.654 343.022 441.049 342.605 441.551 342.595C442.055 342.584 442.474 342.983 442.489 343.485Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.036 350.027C429.05 350.53 428.656 350.946 428.154 350.957C427.652 350.968 427.231 350.569 427.216 350.066C427.201 349.563 427.596 349.147 428.098 349.137C428.601 349.126 429.021 349.524 429.036 350.027Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.507 343.812C418.521 344.315 418.127 344.731 417.625 344.742C417.123 344.753 416.702 344.354 416.687 343.851C416.672 343.348 417.067 342.932 417.569 342.922C418.073 342.91 418.493 343.309 418.507 343.812Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.466 371.844C644.479 372.347 644.086 372.763 643.583 372.774C643.08 372.785 642.66 372.386 642.646 371.883C642.632 371.381 643.026 370.964 643.528 370.954C644.031 370.943 644.451 371.342 644.466 371.844Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.955 371.844C616.968 372.347 616.575 372.763 616.072 372.774C615.569 372.785 615.149 372.386 615.135 371.883C615.12 371.381 615.515 370.964 616.017 370.954C616.52 370.943 616.94 371.342 616.955 371.844Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.445 371.237C589.46 371.74 589.066 372.156 588.563 372.167C588.06 372.178 587.64 371.779 587.625 371.276C587.61 370.774 588.005 370.357 588.507 370.347C589.011 370.336 589.431 370.735 589.445 371.237Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.363 370.64C564.376 371.143 563.983 371.559 563.48 371.57C562.977 371.581 562.557 371.182 562.543 370.679C562.528 370.177 562.923 369.76 563.425 369.75C563.928 369.739 564.347 370.138 564.363 370.64Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.365 369.123C540.379 369.626 539.985 370.042 539.483 370.053C538.981 370.064 538.561 369.665 538.546 369.162C538.531 368.66 538.925 368.243 539.428 368.233C539.93 368.222 540.35 368.621 540.365 369.123Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.433 367.202C517.446 367.705 517.053 368.121 516.55 368.132C516.047 368.143 515.627 367.744 515.613 367.241C515.598 366.739 515.993 366.322 516.495 366.312C516.998 366.301 517.418 366.699 517.433 367.202Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.991 365.078C496.004 365.581 495.611 365.997 495.108 366.008C494.606 366.019 494.185 365.62 494.171 365.117C494.156 364.615 494.551 364.198 495.053 364.188C495.556 364.177 495.976 364.575 495.991 365.078Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.358 361.681C475.371 362.184 474.978 362.6 474.475 362.611C473.973 362.622 473.552 362.223 473.538 361.72C473.523 361.218 473.918 360.801 474.42 360.791C474.923 360.78 475.343 361.179 475.358 361.681Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.354 358.827C457.369 359.33 456.975 359.746 456.472 359.757C455.97 359.768 455.549 359.369 455.534 358.866C455.519 358.364 455.914 357.947 456.416 357.937C456.92 357.926 457.34 358.324 457.354 358.827Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.487 354.781C442.501 355.284 442.107 355.7 441.605 355.711C441.103 355.722 440.682 355.323 440.667 354.82C440.652 354.318 441.047 353.901 441.549 353.891C442.053 353.88 442.473 354.278 442.487 354.781Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.858 443.725C430.873 444.227 430.478 444.645 429.976 444.655C429.474 444.666 429.054 444.267 429.038 443.764C429.024 443.262 429.418 442.845 429.92 442.835C430.424 442.825 430.844 443.223 430.858 443.725Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33 437.51C420.344 438.012 419.95 438.429 419.448 438.439C418.946 438.45 418.525 438.051 418.51 437.549C418.495 437.047 418.891 436.63 419.392 436.62C419.896 436.609 420.315 437.008 420.33 437.51Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.288 465.543C646.302 466.046 645.908 466.464 645.405 466.473C644.902 466.484 644.483 466.084 644.468 465.582C644.454 465.08 644.848 464.663 645.35 464.653C645.853 464.642 646.273 465.039 646.288 465.543Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.778 465.543C618.792 466.046 618.398 466.464 617.895 466.473C617.392 466.484 616.973 466.084 616.958 465.582C616.943 465.08 617.338 464.663 617.84 464.653C618.343 464.642 618.763 465.039 618.778 465.543Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.267 464.936C591.282 465.439 590.888 465.857 590.385 465.866C589.883 465.877 589.463 465.477 589.447 464.975C589.431 464.473 589.827 464.056 590.329 464.046C590.833 464.035 591.253 464.433 591.267 464.936Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.185 464.339C566.199 464.842 565.804 465.258 565.302 465.269C564.8 465.28 564.38 464.88 564.365 464.378C564.35 463.876 564.745 463.459 565.247 463.45C565.75 463.437 566.17 463.836 566.185 464.339Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.187 462.821C542.201 463.324 541.807 463.74 541.305 463.751C540.803 463.761 540.383 463.362 540.368 462.86C540.353 462.358 540.747 461.941 541.25 461.932C541.753 461.92 542.173 462.319 542.187 462.821Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.255 460.9C519.269 461.403 518.874 461.82 518.372 461.83C517.87 461.84 517.45 461.44 517.435 460.938C517.42 460.436 517.815 460.019 518.317 460.01C518.82 459.999 519.24 460.397 519.255 460.9Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.813 458.776C497.827 459.279 497.433 459.696 496.93 459.706C496.427 459.716 496.008 459.316 495.993 458.814C495.978 458.312 496.373 457.895 496.875 457.886C497.378 457.875 497.798 458.273 497.813 458.776Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.18 455.38C477.194 455.882 476.8 456.3 476.297 456.309C475.795 456.321 475.375 455.921 475.36 455.419C475.345 454.917 475.74 454.5 476.242 454.49C476.744 454.48 477.165 454.877 477.18 455.38Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.177 452.525C459.192 453.027 458.798 453.445 458.295 453.454C457.793 453.466 457.373 453.066 457.357 452.563C457.342 452.061 457.737 451.644 458.239 451.634C458.743 451.624 459.163 452.022 459.177 452.525Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.31 448.479C444.325 448.981 443.93 449.398 443.428 449.408C442.926 449.419 442.506 449.02 442.49 448.517C442.475 448.015 442.87 447.598 443.372 447.588C443.875 447.578 444.295 447.976 444.31 448.479Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.858 430.004C430.873 430.507 430.478 430.923 429.976 430.934C429.474 430.945 429.054 430.546 429.038 430.043C429.024 429.541 429.418 429.124 429.92 429.114C430.424 429.103 430.844 429.501 430.858 430.004Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33 423.788C420.344 424.291 419.95 424.707 419.448 424.718C418.946 424.729 418.525 424.33 418.51 423.827C418.495 423.325 418.891 422.908 419.392 422.898C419.896 422.887 420.315 423.285 420.33 423.788Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.288 451.821C646.302 452.324 645.908 452.74 645.405 452.75C644.902 452.762 644.483 452.362 644.468 451.859C644.454 451.357 644.848 450.94 645.35 450.931C645.853 450.92 646.273 451.319 646.288 451.821Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.778 451.821C618.792 452.324 618.398 452.74 617.895 452.75C617.392 452.762 616.973 452.362 616.958 451.859C616.943 451.357 617.338 450.94 617.84 450.931C618.343 450.92 618.763 451.319 618.778 451.821Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.267 451.214C591.282 451.717 590.888 452.133 590.385 452.143C589.883 452.155 589.463 451.755 589.447 451.252C589.432 450.75 589.827 450.333 590.329 450.324C590.833 450.313 591.253 450.712 591.267 451.214Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.185 450.617C566.199 451.12 565.804 451.537 565.302 451.547C564.8 451.558 564.38 451.159 564.365 450.656C564.35 450.154 564.745 449.737 565.247 449.727C565.75 449.716 566.17 450.115 566.185 450.617Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.187 449.1C542.201 449.603 541.807 450.02 541.305 450.03C540.803 450.041 540.383 449.642 540.368 449.139C540.353 448.637 540.747 448.22 541.25 448.21C541.753 448.199 542.173 448.597 542.187 449.1Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.255 447.178C519.269 447.681 518.874 448.097 518.372 448.108C517.87 448.119 517.45 447.719 517.435 447.217C517.42 446.715 517.815 446.298 518.317 446.288C518.819 446.278 519.24 446.676 519.255 447.178Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.813 445.054C497.827 445.557 497.433 445.973 496.93 445.984C496.428 445.994 496.008 445.596 495.993 445.093C495.978 444.591 496.373 444.174 496.875 444.164C497.377 444.154 497.798 444.552 497.813 445.054Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.18 441.658C477.194 442.161 476.8 442.577 476.297 442.588C475.795 442.599 475.375 442.2 475.36 441.697C475.345 441.194 475.74 440.778 476.242 440.768C476.745 440.757 477.165 441.156 477.18 441.658Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.177 438.803C459.192 439.306 458.798 439.722 458.295 439.733C457.793 439.744 457.373 439.345 457.357 438.842C457.342 438.34 457.737 437.923 458.239 437.913C458.743 437.902 459.163 438.301 459.177 438.803Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.31 434.757C444.325 435.26 443.93 435.676 443.428 435.687C442.926 435.698 442.506 435.299 442.49 434.796C442.475 434.294 442.87 433.877 443.372 433.867C443.875 433.856 444.295 434.255 444.31 434.757Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.147 253.948C424.836 251.83 421.043 249.499 418.45 246.884C416.425 244.842 415.296 241.564 415.296 241.564L414.963 254.48C414.963 254.48 414.963 256.12 429.162 263.708C432.586 265.538 439.823 267.833 443.524 269.006C447.155 270.158 454.667 271.547 458.392 272.349C462.884 273.316 471.877 275.216 476.396 276.049C481.54 276.998 497.03 278.881 497.03 278.881L518.472 280.692C518.472 280.692 535.673 282.298 541.404 282.673C547.175 283.049 558.712 283.895 564.491 284.064C570.759 284.247 583.303 284.637 589.574 284.671C596.68 284.709 610.89 285.505 617.995 285.455C624.646 285.408 637.944 285.654 644.593 285.455C651.062 285.261 669.856 285.101 669.856 285.101V273.007C669.856 273.007 659.472 273.713 643.359 273.863C633.662 273.953 622.111 273.455 609.984 273.572C593.164 273.733 575.236 272.775 559.616 272.108C546.72 271.558 535.397 271.4 527.568 270.532C521.559 269.866 507.829 268.37 495.518 267.102C481.77 265.685 479.971 265.708 468.021 262.932C461.486 261.414 455.17 260.545 448.827 259.072C448.827 259.07 434.645 255.741 430.147 253.948Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.946 258.144C429.96 258.647 429.566 259.063 429.064 259.074C428.562 259.085 428.141 258.686 428.126 258.183C428.111 257.681 428.507 257.264 429.008 257.254C429.512 257.243 429.932 257.642 429.946 258.144Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.417 251.928C419.431 252.431 419.037 252.847 418.535 252.858C418.033 252.869 417.612 252.47 417.597 251.967C417.582 251.465 417.978 251.048 418.479 251.038C418.984 251.027 419.403 251.426 419.417 251.928Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.376 279.961C645.389 280.464 644.996 280.88 644.493 280.891C643.99 280.902 643.57 280.503 643.556 280C643.542 279.497 643.936 279.081 644.438 279.071C644.941 279.06 645.361 279.458 645.376 279.961Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.866 279.961C617.879 280.464 617.486 280.88 616.983 280.891C616.481 280.902 616.06 280.503 616.046 280C616.031 279.498 616.426 279.081 616.928 279.071C617.43 279.06 617.85 279.458 617.866 279.961Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.355 279.354C590.37 279.857 589.976 280.273 589.473 280.284C588.97 280.295 588.55 279.896 588.535 279.393C588.52 278.891 588.915 278.474 589.417 278.464C589.921 278.453 590.341 278.851 590.355 279.354Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.273 278.757C565.286 279.26 564.893 279.676 564.39 279.687C563.888 279.698 563.467 279.299 563.453 278.796C563.438 278.294 563.833 277.877 564.335 277.867C564.838 277.856 565.258 278.255 565.273 278.757Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.275 277.24C541.289 277.743 540.895 278.159 540.393 278.17C539.89 278.181 539.471 277.782 539.456 277.279C539.441 276.777 539.835 276.36 540.338 276.35C540.841 276.339 541.261 276.738 541.275 277.24Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.343 275.318C518.356 275.821 517.963 276.237 517.46 276.248C516.957 276.259 516.537 275.86 516.523 275.357C516.508 274.855 516.903 274.438 517.405 274.428C517.908 274.417 518.328 274.816 518.343 275.318Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.901 273.194C496.914 273.697 496.521 274.113 496.018 274.124C495.516 274.135 495.095 273.736 495.081 273.233C495.066 272.731 495.461 272.314 495.963 272.304C496.466 272.293 496.886 272.692 496.901 273.194Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.268 269.799C476.281 270.302 475.888 270.718 475.385 270.729C474.883 270.74 474.462 270.341 474.448 269.838C474.433 269.336 474.828 268.919 475.33 268.909C475.833 268.897 476.253 269.295 476.268 269.799Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.265 266.943C458.28 267.446 457.886 267.862 457.383 267.873C456.881 267.884 456.46 267.485 456.445 266.982C456.43 266.48 456.825 266.063 457.327 266.053C457.831 266.042 458.251 266.441 458.265 266.943Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.397 262.897C443.411 263.4 443.017 263.816 442.515 263.827C442.013 263.838 441.592 263.439 441.577 262.936C441.562 262.434 441.957 262.017 442.459 262.007C442.963 261.996 443.383 262.395 443.397 262.897Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.56 279.16C749.56 279.16 763.984 276.404 768.576 275.425C773.747 274.324 784.095 272.133 789.216 270.817C793.387 269.745 801.758 267.62 805.768 266.053C809.7 264.517 817.595 261.213 820.939 258.636C822.105 257.737 825.513 254.287 825.513 254.287L825.617 242.585C825.617 242.585 822.395 247.22 820.938 248.38C817.439 251.168 809.103 254.82 804.856 256.226C801.018 257.496 793.172 259.51 789.214 260.335C784.085 261.404 773.756 263.204 768.575 263.98C763.984 264.668 749.559 265.831 749.559 265.831L749.56 279.16Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.78 269.799C769.793 270.302 769.4 270.718 768.897 270.729C768.394 270.74 767.975 270.341 767.96 269.838C767.946 269.336 768.34 268.919 768.842 268.909C769.345 268.897 769.765 269.295 769.78 269.799Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.144 254.178C822.157 254.681 821.764 255.097 821.261 255.108C820.758 255.119 820.339 254.72 820.324 254.217C820.309 253.715 820.704 253.298 821.206 253.288C821.708 253.277 822.128 253.675 822.144 254.178Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.973 261.46C806.986 261.963 806.593 262.379 806.09 262.39C805.587 262.401 805.168 262.002 805.153 261.499C805.138 260.997 805.533 260.58 806.035 260.57C806.537 260.559 806.957 260.957 806.973 261.46Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.42 265.944C790.434 266.447 790.04 266.863 789.537 266.874C789.034 266.885 788.615 266.486 788.6 265.983C788.586 265.481 788.98 265.064 789.482 265.054C789.985 265.044 790.404 265.442 790.42 265.944Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.691 458.022C770.704 458.525 770.311 458.941 769.808 458.952C769.306 458.963 768.886 458.563 768.871 458.061C768.857 457.559 769.251 457.142 769.753 457.132C770.255 457.121 770.675 457.519 770.691 458.022Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.054 442.401C823.067 442.904 822.674 443.32 822.171 443.331C821.668 443.342 821.249 442.943 821.234 442.44C821.219 441.938 821.614 441.521 822.116 441.511C822.619 441.5 823.039 441.899 823.054 442.401Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.883 449.683C807.896 450.186 807.503 450.603 807 450.613C806.498 450.624 806.078 450.225 806.063 449.722C806.048 449.22 806.443 448.803 806.945 448.793C807.448 448.782 807.868 449.181 807.883 449.683Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.331 454.168C791.345 454.67 790.951 455.087 790.448 455.097C789.946 455.109 789.526 454.709 789.511 454.206C789.497 453.704 789.891 453.287 790.393 453.277C790.896 453.267 791.315 453.665 791.331 454.168Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.691 444.085C770.704 444.588 770.311 445.004 769.808 445.015C769.306 445.026 768.886 444.627 768.871 444.124C768.857 443.622 769.251 443.205 769.753 443.195C770.255 443.183 770.675 443.582 770.691 444.085Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.054 428.464C823.067 428.967 822.674 429.383 822.171 429.394C821.668 429.405 821.249 429.006 821.234 428.503C821.219 428.001 821.614 427.584 822.116 427.574C822.619 427.563 823.039 427.961 823.054 428.464Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.883 435.746C807.896 436.249 807.503 436.665 807 436.676C806.498 436.687 806.078 436.288 806.063 435.785C806.048 435.283 806.443 434.866 806.945 434.856C807.448 434.845 807.868 435.243 807.883 435.746Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.331 440.231C791.345 440.734 790.951 441.15 790.448 441.161C789.946 441.172 789.526 440.773 789.511 440.27C789.497 439.768 789.891 439.351 790.393 439.341C790.896 439.33 791.315 439.728 791.331 440.231Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.691 363.717C770.705 364.22 770.311 364.636 769.808 364.647C769.306 364.658 768.886 364.259 768.871 363.756C768.857 363.254 769.251 362.837 769.753 362.827C770.256 362.815 770.676 363.214 770.691 363.717Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.056 348.096C823.069 348.599 822.676 349.015 822.173 349.026C821.671 349.037 821.25 348.638 821.236 348.135C821.222 347.633 821.616 347.216 822.118 347.206C822.62 347.195 823.04 347.593 823.056 348.096Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.883 355.378C807.896 355.881 807.503 356.297 807 356.308C806.498 356.319 806.077 355.92 806.063 355.417C806.049 354.915 806.443 354.498 806.945 354.488C807.448 354.477 807.868 354.876 807.883 355.378Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.332 359.863C791.346 360.366 790.952 360.782 790.449 360.793C789.947 360.804 789.527 360.405 789.512 359.902C789.498 359.4 789.892 358.983 790.394 358.973C790.896 358.962 791.316 359.36 791.332 359.863Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.78 351.794C769.793 352.297 769.4 352.713 768.897 352.724C768.394 352.735 767.975 352.336 767.96 351.833C767.946 351.331 768.34 350.914 768.842 350.904C769.345 350.893 769.765 351.291 769.78 351.794Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.144 336.173C822.157 336.676 821.764 337.092 821.261 337.103C820.758 337.114 820.339 336.715 820.324 336.212C820.309 335.709 820.704 335.293 821.206 335.283C821.708 335.271 822.128 335.67 822.144 336.173Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.973 343.455C806.986 343.958 806.593 344.374 806.09 344.385C805.587 344.396 805.168 343.997 805.153 343.494C805.138 342.991 805.533 342.575 806.035 342.565C806.537 342.554 806.957 342.952 806.973 343.455Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.42 347.94C790.434 348.443 790.04 348.859 789.537 348.87C789.034 348.881 788.615 348.482 788.6 347.979C788.586 347.477 788.98 347.06 789.482 347.05C789.985 347.039 790.404 347.438 790.42 347.94Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.624 227.851L454.927 220.192L439.152 220.352C439.152 220.352 433.893 219.992 424.79 220.352C421.508 220.482 414.262 219.658 409.619 221.125C405.11 222.549 402.185 223.754 400.314 229.621V239.33C399.909 470.133 400.516 453.142 400.516 453.142H408.202C408.202 453.142 407.721 236.741 408.311 234.224C408.735 232.416 406.39 228.074 415.17 227.957L454.624 227.851Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.366 452.486H396.757V454.913H411.366V452.486Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.215 238.094H409.741C409.741 238.094 408.996 230.865 410.55 229.312C411.903 227.959 417.6 228.688 417.6 228.688V219.585C417.6 219.585 405.931 218.725 402.643 222.012C399.049 225.606 400.215 238.094 400.215 238.094Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.294 238.094H459.768C459.768 238.094 460.513 230.865 458.959 229.312C457.606 227.959 451.91 228.688 451.91 228.688V219.585C451.91 219.585 463.579 218.725 466.866 222.012C470.461 225.606 469.294 238.094 469.294 238.094Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.357 543.407C749.357 543.407 763.78 540.651 768.372 539.673C773.543 538.572 783.892 536.381 789.013 535.065C793.184 533.992 801.555 531.866 805.565 530.3C809.497 528.765 817.391 525.46 820.735 522.882C821.901 521.984 825.31 518.533 825.31 518.533L825.414 506.832C825.414 506.832 822.191 511.468 820.734 512.628C817.235 515.416 808.899 519.067 804.652 520.474C800.814 521.745 792.968 523.758 789.01 524.583C783.881 525.653 773.552 527.453 768.371 528.23C763.78 528.918 749.355 530.081 749.355 530.081V543.407H749.357Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.493 524.057C433.508 524.559 433.113 524.977 432.611 524.986C432.109 524.998 431.689 524.598 431.673 524.095C431.659 523.593 432.053 523.176 432.555 523.166C433.059 523.157 433.478 523.555 433.493 524.057Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.964 518.449C422.978 518.951 422.584 519.368 422.082 519.378C421.58 519.389 421.159 518.99 421.144 518.487C421.129 517.985 421.524 517.568 422.026 517.559C422.53 517.548 422.95 517.946 422.964 518.449Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.923 544.054C648.937 544.556 648.543 544.974 648.04 544.984C647.537 544.995 647.118 544.595 647.103 544.093C647.089 543.591 647.483 543.174 647.985 543.164C648.488 543.154 648.907 543.551 648.923 544.054Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.413 544.054C621.427 544.556 621.033 544.974 620.53 544.984C620.028 544.995 619.608 544.595 619.593 544.093C619.579 543.591 619.973 543.174 620.475 543.164C620.977 543.154 621.397 543.551 621.413 544.054Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.902 543.447C593.917 543.949 593.523 544.367 593.02 544.377C592.518 544.388 592.098 543.988 592.082 543.486C592.067 542.984 592.462 542.567 592.964 542.557C593.468 542.546 593.887 542.944 593.902 543.447Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.82 542.85C568.834 543.353 568.44 543.769 567.937 543.78C567.435 543.79 567.015 543.391 567 542.889C566.986 542.387 567.38 541.97 567.882 541.961C568.385 541.949 568.804 542.348 568.82 542.85Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.822 541.94C544.837 542.443 544.442 542.859 543.94 542.87C543.437 542.88 543.018 542.481 543.003 541.979C542.988 541.477 543.382 541.06 543.885 541.051C544.388 541.039 544.806 541.437 544.822 541.94Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.89 540.018C521.904 540.521 521.51 540.938 521.007 540.948C520.505 540.958 520.085 540.558 520.07 540.056C520.056 539.554 520.45 539.137 520.952 539.128C521.455 539.117 521.874 539.516 521.89 540.018Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.448 537.894C500.462 538.397 500.068 538.814 499.565 538.824C499.063 538.834 498.643 538.434 498.628 537.932C498.614 537.43 499.008 537.013 499.51 537.004C500.013 536.994 500.432 537.392 500.448 537.894Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.815 535.105C479.829 535.607 479.435 536.024 478.932 536.033C478.43 536.045 478.01 535.645 477.995 535.143C477.981 534.641 478.375 534.224 478.877 534.214C479.379 534.204 479.8 534.603 479.815 535.105Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.812 531.643C461.827 532.145 461.433 532.563 460.93 532.572C460.428 532.584 460.008 532.184 459.992 531.681C459.977 531.179 460.372 530.762 460.874 530.752C461.378 530.742 461.797 531.14 461.812 531.643Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.944 528.204C446.959 528.706 446.564 529.123 446.062 529.133C445.56 529.144 445.14 528.745 445.124 528.242C445.11 527.74 445.505 527.323 446.006 527.313C446.51 527.303 446.929 527.702 446.944 528.204Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.601 533.528C771.614 534.031 771.221 534.449 770.718 534.458C770.216 534.468 769.796 534.069 769.781 533.567C769.767 533.065 770.161 532.648 770.663 532.638C771.166 532.629 771.586 533.026 771.601 533.528Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.151 401.819C793.165 402.322 792.771 402.74 792.268 402.749C791.766 402.759 791.346 402.36 791.331 401.858C791.317 401.356 791.711 400.939 792.213 400.929C792.716 400.919 793.135 401.317 793.151 401.819Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.793 396.577C808.806 397.08 808.413 397.497 807.91 397.507C807.408 397.517 806.988 397.117 806.973 396.615C806.958 396.113 807.353 395.696 807.855 395.687C808.358 395.676 808.778 396.074 808.793 396.577Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.054 389.531C823.067 390.034 822.674 390.452 822.171 390.461C821.668 390.471 821.249 390.072 821.234 389.57C821.219 389.068 821.614 388.651 822.116 388.641C822.618 388.631 823.039 389.028 823.054 389.531Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.15 238.156H457.542V241.19H472.15V238.156Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.539 494.193C404.539 494.193 405.382 493.425 405.732 493.297C405.905 493.234 406.289 493.268 406.472 493.298C406.624 493.325 407.053 493.497 407.053 493.497L407.051 495.104L407.633 495.105L407.64 490.764V490.641L407.646 486.3L407.064 486.299L407.062 487.907C407.062 487.907 406.632 488.079 406.48 488.104C406.297 488.134 405.907 488.184 405.74 488.103C405.382 487.93 404.69 486.914 404.69 486.914C404.69 486.914 405.198 489.744 405.174 490.698C405.147 491.588 404.539 494.193 404.539 494.193Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.637 490.578H405.621V491.006H407.637V490.578Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.64 488.394H405.624V489.001H407.64V488.394Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.64 488.394H405.624V489.608H407.64V488.394Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.633 492.38H405.618V493.594H407.633V492.38Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.981 484.622L402.964 496.759L406.412 496.764L406.429 484.627L402.981 484.622Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.001 483.599L402.981 498.163L403.588 498.163L403.608 483.599L403.001 483.599Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 495.664L401.522 495.24L401.534 486.072L402.996 485.733",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.982 495.664L401.522 495.24L401.534 486.072L402.996 485.733",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.031 493.711C405.569 493.711 406.006 493.274 406.006 492.736C406.006 492.197 405.569 491.761 405.031 491.761C404.492 491.761 404.056 492.197 404.056 492.736C404.056 493.274 404.492 493.711 405.031 493.711Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.037 489.436C405.575 489.436 406.012 488.999 406.012 488.461C406.012 487.922 405.575 487.486 405.037 487.486C404.498 487.486 404.062 487.922 404.062 488.461C404.062 488.999 404.498 489.436 405.037 489.436Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.372 481.805H404.583V500.01H411.372V481.805Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.791 502.314H412.81",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 480.982H410.013V482.401H410.888V480.982Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 482.402H410.013V483.552H410.888V482.402Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 480.409H410.013V480.982H410.888V480.409Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 480.409H410.013V483.552H410.888V480.409Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.433 481.513H410.889V482.445H411.433V481.513Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 490.063H410.013V491.483H410.888V490.063Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 491.484H410.013V492.635H410.888V491.484Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 489.49H410.013V490.061H410.888V489.49Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 489.49H410.013V492.633H410.888V489.49Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.433 490.594H410.889V491.526H411.433V490.594Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 499.151H410.013V500.57H410.888V499.151Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 500.57H410.013V501.719H410.888V500.57Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 498.577H410.013V499.151H410.888V498.577Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.888 498.577H410.013V501.719H410.888V498.577Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.433 499.682H410.889V500.613H411.433V499.682Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.974 478.771H411.153V503.044H412.974V478.771Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.581 478.771H413.154V503.044H415.581V478.771Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.957 242.163H456.431C456.431 242.163 457.176 234.934 455.622 233.381C454.269 232.028 448.573 232.757 448.573 232.757V223.654C448.573 223.654 460.242 222.794 463.529 226.081C467.123 229.675 465.957 242.163 465.957 242.163Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.997 242.496H453.389V245.53H467.997V242.496Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.436 230.706L449.739 223.047L433.964 223.207C433.964 223.207 428.705 222.847 419.602 223.207C416.321 223.337 409.073 222.513 404.431 223.98C399.922 225.404 396.997 226.609 395.126 232.476V242.185C394.721 472.988 395.328 455.996 395.328 455.996H403.014C403.014 455.996 402.533 239.595 403.123 237.078C403.547 235.27 401.202 230.928 409.982 230.811L449.436 230.706Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.264 240.949H403.789C403.789 240.949 403.045 233.72 404.598 232.167C405.951 230.814 411.648 231.543 411.648 231.543V222.44C411.648 222.44 399.979 221.58 396.692 224.867C393.097 228.462 394.264 240.949 394.264 240.949Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.731 455.097H392.123V457.524H406.731V455.097Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.37 525.552C641.37 528.703 638.816 531.256 635.667 531.256C632.518 531.256 629.963 528.703 629.963 525.552C629.963 522.404 632.517 519.85 635.667 519.85C638.816 519.849 641.37 522.402 641.37 525.552Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.646 525.558C639.646 527.754 637.865 529.536 635.669 529.536C633.473 529.536 631.692 527.754 631.692 525.558C631.692 523.364 633.473 521.581 635.669 521.581C637.865 521.581 639.646 523.363 639.646 525.558Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.682 525.568L637.502 526.77L635.682 525.568Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.682 525.568L637.502 526.77",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.017 525.548C636.017 525.727 635.872 525.871 635.693 525.871C635.514 525.871 635.368 525.727 635.368 525.548C635.368 525.369 635.514 525.223 635.693 525.223C635.872 525.223 636.017 525.369 636.017 525.548Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.694 528.967L634.455 527.676L633.694 528.967Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.694 528.967L634.455 527.676",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.192 527.532L633.429 526.795L632.192 527.532Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.192 527.532L633.429 526.795",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.736 525.521H633.143H631.736Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.736 525.521H633.143",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.3 523.563L633.511 524.244L632.3 523.563Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.3 523.563L633.511 524.244",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.748 522.182L634.467 523.352L633.748 522.182Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.748 522.182L634.467 523.352",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.693 521.633V523.04V521.633Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.693 521.633V523.04",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.638 522.182L636.938 523.377L637.638 522.182Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.638 522.182L636.938 523.377",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.071 523.616L637.877 524.262L639.071 523.616Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.071 523.616L637.877 524.262",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.582 525.48H638.202H639.582Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.582 525.48H638.202",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.153 527.505L637.851 526.737L639.153 527.505Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.153 527.505L637.851 526.737",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.651 528.941L636.925 527.72L637.651 528.941Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.651 528.941L636.925 527.72",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.643 525.561C639.643 527.757 637.86 529.539 635.664 529.539C633.468 529.539 631.688 527.757 631.688 525.561C631.688 523.366 633.468 521.584 635.664 521.584C637.86 521.584 639.643 523.365 639.643 525.561Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.712 502.595H602.615V503.272H603.712V502.595Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.615 502.595H601.727V503.272H602.615V502.595Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.155 502.595H603.712V503.272H604.155V502.595Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.154 502.595H601.727V503.272H604.154V502.595Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.302 503.272H602.582V503.692H603.302V503.272Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.139 503.763L600.503 503.699L599.234 501.852",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.139 503.763L600.503 503.699L599.234 501.852",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.234 501.382H581.448V502.596H599.234V501.382Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.703 508.939H632.633V505.297H634.496V504.042H636.882V505.277H638.704L638.703 508.939Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.006 502.618H634.909V503.295H636.006V502.618Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.893 502.618H636.005V503.295H636.893V502.618Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.909 502.618H634.466V503.295H634.909V502.618Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.893 502.618H634.466V503.295H636.893V502.618Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.039 503.295H635.319V503.715H636.039V503.295Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.387 501.875L638.118 503.723L634.481 503.786",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.387 501.875L638.118 503.723L634.481 503.786",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.173 501.405H639.387V502.619H657.173V501.405Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.933 556.71H632.077V562.172H639.933V556.71Z",
    fill: "#131F2E",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_34728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacility);
export default __webpack_public_path__ + "static/media/facility.d3f5e9695590c644cdf427d3e22f1eaa.svg";
export { ForwardRef as ReactComponent };